import React from 'react';
import styles from './MultiTab.module.scss';
import globalStyles from 'common/global.module.scss';
import { Row } from 'antd';
import { FormField } from 'common';
import { NameTab } from '..';
import {
  BlockLotFormFields,
  PropertyDocumentTypeFormFields,
  AddressesFormFields,
} from 'pages/Search/templates';
import { FieldArray } from 'redux-form';

const MultiTab: React.FC<{
  handleFieldFocus: any;
}> = ({ handleFieldFocus }) => {
  return (
    <>
      <Row type="flex" align="middle">
        <FormField
          className={'m-0'}
          inputType="checkbox"
          name="multiTab.searchByBlockLot"
          id="multiTab.searchByBlockLot"
          tooltip="Block and Lot"
        >
          Block/Lot
        </FormField>
      </Row>
      <PropertyDocumentTypeFormFields
        tabNamePrefix="multiTab"
        rowStyle={globalStyles.row}
        recordedDocumentsFieldNameSuffix="ByBlockLot"
      />
      <BlockLotFormFields
        handleFieldFocus={handleFieldFocus}
        tabNamePrefix="multiTab"
        rowStyle={globalStyles.row}
        inputStyle={globalStyles.input}
        autoFocusFirstField={false}
      />

      <Row type="flex" align="middle">
        <FormField
          className={'m-0'}
          inputType="checkbox"
          name="multiTab.searchByName"
          id="multiTab.searchByName"
          tooltip="Name"
        >
          Name
        </FormField>
      </Row>
      <NameTab
        handleFieldFocus={handleFieldFocus}
        tabNamePrefix="multiTab"
        className={globalStyles.row}
        autoFocusIndividual={false}
      />

      <Row type="flex" align="middle" className={styles.topSpacing}>
        <FormField
          className={'m-0'}
          inputType="checkbox"
          name="multiTab.searchByAddress"
          id="multiTab.searchByAddress"
          tooltip="Address"
        >
          Address
        </FormField>
      </Row>
      <Row type="flex" align="middle" className={globalStyles.row}>
        <FormField
          className={'m-0'}
          inputType="checkbox"
          name="multiTab.ecbsByAddress"
          id="multiTab.ecbsByAddress"
          tooltip="Environmental Control Board Judgments by Address"
        >
          ECB by Address
        </FormField>
        <FormField
          className={'m-0'}
          inputType="checkbox"
          name="multiTab.emergencyRepairs"
          id="multiTab.emergencyRepairs"
          tooltip="NYC Emergency Repair"
        >
          NYC Emergency Repair
        </FormField>
      </Row>
      <div className={globalStyles.row}>
        <FieldArray
          name="multiTab.addresses"
          component={AddressesFormFields}
          inputStyle={globalStyles.input}
          rowStyle={globalStyles.row}
          tabNamePrefix="multiTab"
          handleFieldFocus={handleFieldFocus}
        />
      </div>
    </>
  );
};

export default React.memo(MultiTab);
